import { FilePathUtils } from '@/config';
import { Link } from '@/i18n/routing';
import {
  CallIcon,
  Location05Icon,
  MailOpen02Icon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import Image from 'next/image';
import { Logo } from '../logo';
import SupportActions from '../whatsapp-chat-support/support-action';
import { socialIconToMap } from './footer-content';

export default function DemoFooter({ customer }: { customer: any }) {
  return (
    <>
      <SupportActions />
      <footer className="rounded-t-md bg-primary-900 py-15">
        <div className="container flex flex-col gap-8 justify-between px-4 mx-auto lg:flex-row">
          <div>
            <div className="mb-4">
              <Logo
                src={
                  (customer?.logoWhite &&
                    `${FilePathUtils.customerLogoPath(customer.id, 'white')}/${customer.logoWhite}`) ??
                  ''
                }
                variant="white"
                width={175}
                height={34}
              />
            </div>
            <ul className="space-y-2 text-base font-normal text-gray-300">
              <div className="flex gap-2 items-center">
                <HugeiconsIcon
                  icon={Location05Icon}
                  height={20}
                  width={20}
                  className="text-primary-300"
                />
                <li>City Name</li>
              </div>
              <div className="flex gap-2 items-center">
                <HugeiconsIcon
                  icon={CallIcon}
                  height={20}
                  width={20}
                  className="text-primary-300"
                />
                <li>(123) 456-7890</li>
              </div>
              <div className="flex gap-2 items-center">
                <HugeiconsIcon
                  icon={MailOpen02Icon}
                  height={20}
                  width={20}
                  className="text-primary-300"
                />
                <li>email@example.com</li>
              </div>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-xl mb-[22px]">
              Company
            </h4>
            <ul className="grid gap-4 text-base font-normal text-gray-300">
              <li>
                <Link href={'/about-us'}>About us</Link>
              </li>
              <li>
                <Link href={'/terms-and-conditions'}>Terms and Conditions</Link>
              </li>
              <li>
                <Link href={'/privacy-policy'}>Privacy Policy</Link>
              </li>
              <li>
                <Link href={'/cookie-policy'}>Cookie Policy</Link>
              </li>
              <li>
                <Link href={'/refund-policy'}>Refund policy</Link>
              </li>
              <li>
                <Link href={'/contact-us'}>Contact us</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-xl mb-[22px]">
              Resources
            </h4>
            <ul className="grid gap-4 text-base font-normal text-gray-300">
              <li>
                <Link href="/courses">Courses</Link>
              </li>
              <li>
                <Link href="/my-classes">My classes</Link>
              </li>
              <li>
                <Link href="/profile">My profile</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white text-xl mb-[22px]">
              Social Media
            </h4>
            <div className="flex justify-start mt-4 space-x-2">
              {Object.keys(socialIconToMap).map(key => (
                <Link href="#" key={key} className="p-2 bg-white rounded-md">
                  {socialIconToMap[key as keyof typeof socialIconToMap]}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4  py-4 md:py-[56px]">
          <div className="w-full h-[1px] bg-primary-700"></div>
        </div>

        <div className="text-sm text-center text-gray-400">
          Copyright ©2023. All Rights Reserved.
        </div>

      </footer>
    </>
  );
}
